import React from "react";
import { connect } from "react-redux";
import { Actions as PAYROLL_ACTIONS } from "../../store/actions/payrollActions";
import { ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import PayrollReviewReport from "./pages/PayrollReviewReport";
import { useState } from "react";

const SomethingIsOffModal = ({ setOpenModal, modalState, period, rejectPayPeriod }) => {
	const [note, setNote] = useState("");
	const [payslips, setPayslips] = useState([]);

	const handlePayslips = (payslipId) => {
		const payslipsCopy = [...payslips];
		const index = payslipsCopy.indexOf(payslipId);
		if (index > -1) {
			payslipsCopy.splice(index, 1);
		} else {
			payslipsCopy.push(payslipId);
		}
		setPayslips(payslipsCopy);
	};

	const handleReport = () => {
		rejectPayPeriod(period.id, payslips, note);
	};
	if (!modalState) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "65%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={setOpenModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Something is off</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingRight: 0, paddingTop: 0, paddingBottom: 15 }}
						>
							<div
								className="row d-flex justify-content-center"
								style={{ marginTop: 20 }}
							>
								<div
									className="col-auto"
									style={{ width: "75%", margin: "auto", marginBottom: 10 }}
								>
									<PayrollReviewReport
										forReport={true}
										checklist={payslips}
										onCheck={handlePayslips}
									/>
								</div>
								<div
									className="col-auto"
									style={{ width: "75%", margin: "auto" }}
								>
									<h3 className="font-w700 text-left">Note</h3>
									<textarea
										className="form-control form-input"
										type="text"
										name="note"
										value={note}
										onChange={(e) => setNote(e.target.value)}
										style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
									></textarea>
									<button
										type="button"
										className="btn btn-danger pull-right"
										disabled={!note && !payslips.length}
										style={{ marginTop: 20 }}
										onClick={() => handleReport()}
									>
										<ExclamationTriangleIcon style={{ height: "1.5em", float: "left" }} />
										<div style={{ float: "left", marginLeft: 5 }}>Report</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		modalState: state?.payroll?.approvalModal,
		period: state?.payroll?.payPeriodDetails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: () => dispatch(PAYROLL_ACTIONS.setOpenApprovalModal(false)),
	rejectPayPeriod: (id, payslips, note) => dispatch(PAYROLL_ACTIONS.reviewPayPeriod({ id, action: "Rejected", payslips, note })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SomethingIsOffModal);
